<template>
  <div ref="fullScreen" class="all_content_wrap">
    <div class="top">
      <img id="top_bg" src="../../../assets/images/top_bg.png" />
      <!-- <div style="width: 100%; height: 100%;background-image: url(./img/top_bg.png);"></div> -->
      <div id="time_div" style="color: #0ff7ff"></div>
      <div @click="fullScreen" class="full_btn">
        {{ isFullScreen ? '退出全屏' : '进入全屏' }}
      </div>
    </div>
    <div class="mian">
      <div class="column side">
        <div class="chart first_box" id="population">
          <div class="titlegaga">数据概览</div>
          <div class="first_box1">
            <div class="first_box_box">
              <div class="center">
                <div class="color_f">注册用户数</div>
                <div class="color_f_num">
                  <CountTo
                    :startVal="beginUserAmount"
                    :endVal="endUserAmount"
                    :duration="3000"
                  ></CountTo>
                  <!-- {{firstAreaData.userAmount}} -->
                </div>
              </div>
              <div class="center">
                <div class="color_f">累计储值金额</div>
                <div class="color_f_num">
                  <CountTo
                    :startVal="beginRechargeMoney"
                    :endVal="endRechargeMoney"
                    :decimals="2"
                    :duration="4000"
                  ></CountTo>
                  <!-- {{ firstAreaData.rechargeMoney }} -->
                </div>
              </div>
            </div>
            <div class="first_box_box m_t_40">
              <div class="center">
                <div class="color_f">区域数量</div>
                <div class="color_f_num">
                  <CountTo
                    :startVal="beginAreaAmount"
                    :endVal="endAreaAmount"
                    :duration="3000"
                  ></CountTo>
                  <!-- {{ firstAreaData.areaAmount }} -->
                </div>
              </div>
              <div class="center">
                <div class="color_f">累计消费金额</div>
                <div class="color_f_num">
                  <CountTo
                    :startVal="beginConsumeMoney"
                    :endVal="endConsumeMoney"
                    :decimals="2"
                    :duration="4000"
                  ></CountTo>
                  <!-- {{ firstAreaData.consumeMoney }} -->
                </div>
              </div>
            </div>
            <div class="first_box_box m_t_40">
              <div class="center">
                <div class="color_f">运营设备数</div>
                <div class="color_f_num">
                  <!-- <CountTo
                    :startVal="beginRechargeMoney"
                    :endVal="endRechargeMoney"
                    :decimals="2"
                    :duration="4000"
                  ></CountTo> -->
                  {{ deviceNum }}
                </div>
              </div>

              <div class="center">
                <div class="color_f">累计消费订单数</div>
                <div class="color_f_num">
                  <CountTo
                    :startVal="beginOrderNum"
                    :endVal="endOrderNum"
                    :duration="4000"
                  ></CountTo>
                  <!-- {{ firstAreaData.consumeMoney }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chart" id="checkCount1">
          <month-custom ref="consume" :data="monthConsume"></month-custom>
        </div>
        <div class="chart" id="checkCount">
          <el-carousel indicator-position="none" :height="setHeight+'px'">
            <el-carousel-item>
              <UseDeviceRateByDayVue
                ref="day"
                :height="setHeight"
                :data="dailyData"
              ></UseDeviceRateByDayVue>
            </el-carousel-item>
            <el-carousel-item>
              <UseDeviceRateByMonthVue
                ref="month"
                :height="setHeight"
                :data="monthlyData"
              ></UseDeviceRateByMonthVue>
            </el-carousel-item>
            <el-carousel-item>
              <UseDeviceRateByYearVue
                ref="year"
                :height="setHeight"
                :data="yearsData"
              ></UseDeviceRateByYearVue>
            </el-carousel-item>
            <el-carousel-item>
              <UseDeviceRateByAll
                ref="all"
                :height="setHeight"
                :data="allData"
              ></UseDeviceRateByAll>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="column middle">
        <div class="moddleMap" id="map_div">
          <china
            ref="china"
            :orderNum="endTodayOrderNum"
            :onlineDeviceNum="onlineDeviceNum"
            :deviceNum="deviceNum"
            :beginOrder="beginOrder"
            :endOrder="endOrder"
            :data="chinaData"
          ></china>
        </div>
        <div class="moddleMajor">
          <MonthActiveMember
            ref="active"
            :data="activeMembers"
          ></MonthActiveMember>
        </div>
      </div>

      <div class="column side">
        <div class="chart" id="flowOutCount">
          <div class="main">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            当日：储值<span class="seh" style="color: #fc5f29; background: none"
              ><CountTo
                :startVal="beginTodayRechargeMoney"
                :endVal="endTodayRechargeMoney"
                :decimals="2"
                :duration="4000"
              ></CountTo></span
            >&nbsp;&nbsp;消费<span class="seh" style="color: #fc5f29; background: none"
              ><CountTo
                :startVal="beginTodayConsumeMoney"
                :endVal="endTodayConsumeMoney"
                :decimals="2"
                :duration="4000"
              ></CountTo
            ></span>
          </div>
          <div class="box">
            <!-- 顶部、底部白色渐变 -->
            <!-- <div class="header-blur"></div>
            <div class="footer-blur"></div> -->
            <!-- 轮播列表 -->
            <div class="warp" v-if="record.length">
              <vue-seamless-scroll
                :data="record"
                ref="seamlessScroll"
                @ScrollEnd="srcollEnd"
                :class-option="{
                  step: 3,
                }"
                :limitMoveNum="20"
              >
                <ul>
                  <li
                    v-for="item in record"
                    :key="'lunbo' + item.id"
                    :id="'id' + item.id"
                  >
                    <span class="setC"
                      >{{
                        item.areaName && item.areaName.length > 4
                          ? item.areaName.substring(0, 4)
                          : item.areaName
                      }}-{{
                        item.customerName && item.customerName.length > 3
                          ? item.customerName.substring(0, 3)
                          : item.customerName
                      }}-{{ item.customerPhone
                      }}{{ item.occurrenceTime.substring(11, 21) }}{{ item.type
                      }}<span class="num">{{
                        item.occurrenceAmount.toFixed(2)
                      }}</span
                      >元</span
                    >
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
        <div class="chart" id="flowInCount">
          <MonthRegister ref="register" :data="monthRegister"></MonthRegister>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//值变了调用changeData(value);结构需要一致

import {
  getFirstAreaData,
  getServiceCustom,
  get12MonthsCustom,
  getDeviceLocations,
  getActiveMembers,
  getSevenConsumeDatas,
  getChuzhiCustomRecord,
  getOnlineDeviceNum,
} from '../../../api/dashboard/dashboard';
import vueSeamless from 'vue-seamless-scroll';
import CountTo from '../../../components/CountTo/vue-countTo.vue';
import MonthActiveMember from '../../../components/DashboardChart/MonthActiveMember.vue';
import MonthCustom from '../../../components/DashboardChart/MonthCustom.vue';
import MonthRegister from '../../../components/DashboardChart/MonthRegister.vue';
import UseDeviceRateByYearVue from '../../../components/DashboardChart/UseDeviceRateByYear.vue';
import UseDeviceRateByMonthVue from '../../../components/DashboardChart/UseDeviceRateByMonth.vue';
import UseDeviceRateByDayVue from '../../../components/DashboardChart/UseDeviceRateByDay.vue';
import China from '../../../components/DashboardChart/China.vue';
import UseDeviceRateByAll from '../../../components/DashboardChart/UseDeviceRateByAll.vue';
export default {
  components: {
    MonthRegister,
    MonthCustom,
    MonthActiveMember,
    UseDeviceRateByYearVue,
    UseDeviceRateByMonthVue,
    UseDeviceRateByDayVue,
    vueSeamless,
    China,
    UseDeviceRateByAll,
    CountTo,
  },
  data() {
    return {
      isFullScreen: false,
      money: 100,
      chuzhiMoney: 0,
      customMoney: 0,
      record: [],
      beginUserAmount: 0,
      endUserAmount: 0,
      beginAreaAmount: 0,
      endAreaAmount: 0,
      onlineDeviceNum: 0,
      deviceNum: 0,
      endOrder:0,
      beginOrder:0,
      beginRechargeMoney: 0,
      endRechargeMoney: 0,
      beginConsumeMoney: 0,
      endConsumeMoney: 0,
      beginTodayRechargeMoney: 0,
      endTodayRechargeMoney: 0,
      setHeight:0,
      beginTodayConsumeMoney: 0,
      endTodayConsumeMoney: 0,
      beginOrderNum: 0,
      endOrderNum: 0,
      beginTodayOrderNum: 0,
      endTodayOrderNum: 0,
      firstAreaData: {},
      allData: [],
      chinaData: [],
      bakRecord:[],
      activeMembers: [],
      dailyData: [],
      monthlyData: [],
      yearsData: [],
      monthConsume: [],
      monthRegister: [],
      recordInterval: null,
      rightData: [],
      lastConsumeOrderId: '',
      lastRechargeId: '',
    };
  },
  mounted() {
    this.getData();
    setInterval(() => {
      this.getQuicklyData();
      // let id = this.record[this.record.length-10].id;
      // let lastData = document.querySelector("#id"+id);
      // let wrap = document.querySelector("ul");
      // // console.error("lastData",lastData.offsetTop)
      // console.error("lastData",wrap)
    }, 5000);
    setInterval(() => {
      this.getSlowlyData();
    }, 20000);
    setInterval(() => {
      this.getMiddleData();
    }, 30000);
  },
  created() {
    window.onkeydown = function (event) {
      if (event.keyCode === 122) {
        event.preventDefault();
        event.returnValue = false;
      }
    };
    window.addEventListener('resize', () => {
      if (document.fullscreenElement) {
        this.isFullScreen = true;
      } else {
        this.isFullScreen = false;
      }
      this.setSize();
    });
    var mark = 'monitor';
    this.setSize();
    $('#time_div').html(getNowDate());
    setInterval(function () {
      $('#time_div').html(getNowDate());
    }, 1000);
    // 获取系统当前时间
    function getNowDate() {
      var date = new Date();
      var year = date.getFullYear(); //获取当前年份
      var mon = date.getMonth() + 1; //获取当前月份
      var da = date.getDate(); //获取当前日
      var h = date.getHours(); //获取小时
      if (h < 10) {
        h = '0' + h;
      }
      var m = date.getMinutes(); //获取分钟
      if (m < 10) {
        m = '0' + m;
      }
      var s = date.getSeconds(); //获取秒
      if (s < 10) {
        s = '0' + s;
      }
      var times = year + '年' + mon + '月' + da + '日 ' + h + ':' + m + ':' + s;
      return times;
    }
  },
  methods: {
    srcollEnd(){
      console.error("滚动完成");
      // this.record.splice(0);
      // this.record.push(...this.bakRecord);
    },
    getMiddleData() {
      getDeviceLocations().then(res => {
        this.chinaData.splice(0);
        this.deviceNum = 0;
        res.data.list.forEach(item => {
          item.name = item.areaName;
          this.chinaData.push(item);
          this.deviceNum += item.equipmentCount;
        });
        this.$refs.china.init();
      });
    },
    getQuicklyData() {
      getFirstAreaData().then(res => {
        this.beginUserAmount = this.endUserAmount;
        this.endUserAmount = res.data.userAmount;
        this.beginAreaAmount = this.endAreaAmount;
        this.endAreaAmount = res.data.areaAmount;
        this.beginRechargeMoney = this.endRechargeMoney;
        this.endRechargeMoney = res.data.rechargeMoney;
        this.beginConsumeMoney = this.endConsumeMoney;
        this.endConsumeMoney = res.data.consumeMoney;
        this.beginTodayRechargeMoney = this.endTodayRechargeMoney;
        this.endTodayRechargeMoney =
          res.data.todayRechargeAndConsume.rechargeAmount;
        this.beginTodayConsumeMoney = this.endTodayConsumeMoney;
        this.endTodayConsumeMoney =
          res.data.todayRechargeAndConsume.consumeAmount;
        this.beginOrderNum = this.endOrderNum;
        this.endOrderNum = res.data.consumeOrderAmount;
        this.beginTodayOrderNum = this.endTodayOrderNum;
        this.beginOrder =
          this.endOrder;
        this.endOrder =
          res.data.todayRechargeAndConsume.consumeOrderAmount;
      });
    },
    getSlowlyData() {
      let params = {};
      if (this.lastConsumeOrderId) {
        params.lastConsumeOrderId = this.lastRechargeId;
      }
      if (this.lastRechargeId) {
        params.lastRechargeId = this.lastRechargeId;
      }
      getChuzhiCustomRecord({ params: params }).then(res => {
        let record = res.data.list;
        this.lastRechargeId = res.data.lastRechargeId;
        this.lastConsumeOrderId = res.data.lastConsumeOrderId;
        if (record.length > 0) {
          if (this.record.length > 0) {
            // this.bakRecord.splice(0,record.length);
            // this.bakRecord.push(...record);
            this.record.push(...record);
          } else {
            record.forEach(item => {
              this.record.push(item);
              // this.bakRecord.push(item);
            });
          }
        }
        this.$refs.seamlessScroll.reset()
      });
      getOnlineDeviceNum().then(res => {
        this.onlineDeviceNum = res.data;
      });
      getServiceCustom().then(res => {
        let totalPercent = 0;
        let data1 = res.data.filter(item => item.mode == '本日')[0].details;
        let dailyTotal = 0;
        this.dailyData.splice(0);
        for (let i = 0; i < data1.length; i++) {
          dailyTotal += data1[i].money;
        }
        data1.forEach(item => {
          let value = {};
          value.percent = Number((item.money / dailyTotal).toFixed(2));
          totalPercent += value.percent;
          value.item = item.serviceName;
          value.money = (item.money / 10000).toFixed(2);
          this.dailyData.push(value);
        });
        this.$refs.day.initChart();
        let data2 = res.data.filter(item => item.mode == '本月')[0].details;
        let monthTotal = 0;
        totalPercent = 0;
        this.monthlyData.splice(0);
        for (let i = 0; i < data2.length; i++) {
          monthTotal += data2[i].money;
        }
        data2.forEach(item => {
          let value = {};
          value.percent = Number((item.money / monthTotal).toFixed(2));
          totalPercent += value.percent;
          value.item = item.serviceName;
          value.money = (item.money / 10000).toFixed(2);
          this.monthlyData.push(value);
        });
        this.$refs.month.initChart();
        let data3 = res.data.filter(item => item.mode == '本年')[0].details;
        let yearTotal = 0;
        totalPercent = 0;
        this.yearsData.splice(0);
        for (let i = 0; i < data3.length; i++) {
          yearTotal += data3[i].money;
        }
        data3.forEach(item => {
          let value = {};
          value.percent = Number((item.money / yearTotal).toFixed(2));
          totalPercent += value.percent;
          value.item = item.serviceName;
          value.money = (item.money / 10000).toFixed(2);
          this.yearsData.push(value);
        });
        this.$refs.year.initChart();
        let data = res.data.filter(item => item.mode == '全部')[0].details;
        let allTotal = 0;
        this.allData.splice(0);
        for (let i = 0; i < data.length; i++) {
          allTotal += data[i].money;
        }
        totalPercent = 0;
        data.forEach(item => {
          let value = {};
          value.percent = Number((item.money / allTotal).toFixed(2));
          totalPercent += value.percent;
          value.item = item.serviceName;
          value.money = (item.money / 10000).toFixed(2);
          this.allData.push(value);
        });
        if (totalPercent > 1) {
          this.allData[0].percent = Number(
            (this.allData[0].percent - (totalPercent - 1).toFixed(2)).toFixed(2)
          );
        }
        this.$refs.all.initChart();
      });
      get12MonthsCustom().then(res => {
        this.monthConsume.splice(0);
        res.data.forEach(item => {
          item.money = Number((item.money / 10000).toFixed(2));
          this.monthConsume.push(item);
        });
        this.$refs.consume.initChart();
      });
      getActiveMembers().then(res => {
        this.activeMembers.splice(0);
        res.data.list.forEach(item => {
          this.activeMembers.push(item);
        });
        this.$refs.active.initChart();
      });
      getSevenConsumeDatas().then(res => {
        this.monthRegister.splice(0);
        res.data.forEach(item => {
          this.monthRegister.push(item);
        });
        this.$refs.register.initChart();
      });
    },
    getData() {
      this.getQuicklyData();
      this.getSlowlyData();
      this.getMiddleData();
    },
    setSize() {
      var screenHeight = screen.height;
      var screenWidth = document.body.clientWidth;
      var topHeight = (screenWidth / 1920) * 94;
      var mainHeight = screenHeight - topHeight;
      var chartHeight = (mainHeight - 90) / 8;
      var moddleMapHeight = chartHeight * 5.8;
      var moddleMajorHeight = chartHeight * 2.4 + 10;
      this.$nextTick(() => {
        let topBg = document.querySelector('#top_bg');
        let top = document.querySelector('.top');
        let mian = document.querySelector('.mian');
        let population = document.querySelector('#population');
        let checkCount1 = document.querySelector('#checkCount1');
        let checkCount = document.querySelector('#checkCount');
        let flowOutCount = document.querySelector('#flowOutCount');
        let flowInCount = document.querySelector('#flowInCount');
        let moddleMap = document.querySelector('.moddleMap');
        let moddleMajor = document.querySelector('.moddleMajor');
        topBg.style.height = topHeight + 'px';
        top.style.height = topHeight + 'px';
        mian.style.height = mainHeight + 'px';
        moddleMap.style.height = moddleMapHeight + 'px';
        population.style.height = chartHeight * 2.6 + 'px';
        checkCount1.style.height = chartHeight * 2.8 + 'px';
        checkCount.style.height = chartHeight * 2.8 + 'px';
        this.setHeight = chartHeight * 2.8;
        moddleMajor.style.height = moddleMajorHeight + 'px';
        flowOutCount.style.height = chartHeight * 5.4 + 10 + 'px';
        flowInCount.style.height = chartHeight * 2.8 + 'px';
      });
    },
    fullScreen() {
      if (this.isFullScreen) {
        this.quitFullScreen();
        return;
      }
      let element = this.$refs.fullScreen;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
      this.isFullScreen = true;
    },
    quitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else {
        window.parent.showTopBottom();
      }
      this.isFullScreen = false;
    },
  },
};
</script>

<style lang="scss">
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 100%;
  margin: 0;
}
.color_f {
  color: #fff;
  font-size: 1vw;
}
.setC {
  color: #70d1ec;
  font-size: 1vw;
}
.color_f_num {
  color: #fc5f29;
  font-family: 'a';
  font-size: 1.4vw;
}
.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30%;
}
.m_t_40 {
  margin-top: 10px;
}
.m_t_20 {
  margin-top: 20px;
}
.num {
  font-size: 1vw;
  font-family: 'a';
  color: #fc5f29;
}

.first_box {
  height: 50%;
}
.first_box1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-top: 20px;
  width: 100%;
  height: 70%;
}
.first_box_box {
  width: 100%;
  height: 16%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.all_content_wrap {
  // overflow-y: scroll;
}
* {
  box-sizing: border-box;
}
#time_div {
  color: #0ff7ff;
  position: absolute;
  right: 140px;
  font-size: 18px;
  font-weight: 500;
  top: 24%;
}
.full_btn {
  color: white;
  position: absolute;
  right: 30px;
  top: 24%;
}
.full_btn:hover {
  cursor: pointer;
}
body {
  margin: 0;
  padding: 0;
}
.top {
  width: 100%;
  position: relative;
  /* margin-bottom: 10px; */
  /* background-image: url(./img/top_bg.png); */
}
/* 创建三个相等的列 */
.column {
  float: left;
}
.column.side {
  width: 26%;
}
.column.middle {
  width: 48%;
}
/* 列后清除浮动 */
.mian {
  /* :after */
  content: '';
  /* display: table; */
  clear: both;
  background-image: url(../../../assets/images/bottom_bg.png);
  padding-top: 10px;
}
.chart {
  border-style: solid;
  border-width: 1px;
  border-color: #2f50a8;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 5px;
  position: relative;
}
.moddleMap {
  border-style: solid;
  border-width: 1px;
  border-color: #2f50a8;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 5px;
  /* text-align: center; */
}
.moddleMajor {
  border-style: solid;
  border-width: 1px;
  border-color: #2f50a8;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 5px;
}

.main {
  position: absolute;
  top: 2px;
  right: 0px;
  width: 100%;
  height: 50px;
  // transform: translate(-50%, -50%);
  overflow: hidden;
  text-align: center;
  background-color: transparent;
  line-height: 50px;
  color: #fff;
  font-size: 1.2vw;
  // font-family: 'a';
}

.main div {
  position: absolute;
}
.main span {
  background: none;
}
.main :nth-child(1) {
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  animation: run1 3s linear infinite;
  /* animation-delay: 0s;  */
  background: linear-gradient(to right, cyan, #acd, #fff);
}

.main :nth-child(2) {
  top: 0;
  right: 0;
  height: 100%;
  width: 2px;
  animation: run2 3s linear infinite;
  /* animation-delay: 1s; 设置动画延迟加载时间*/
  background: linear-gradient(to bottom, cyan, #acd, #fff);
}

.main :nth-child(3) {
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  animation: run3 3s linear infinite;
  /* animation-delay: 2s; 设置动画延迟加载时间*/
  background: linear-gradient(to right, #fff, #acd, cyan);
}

.main :nth-child(4) {
  top: 0;
  left: 0;
  height: 100%;
  width: 2px;
  animation: run4 3s linear infinite;
  /* animation-delay: 3s; 设置动画延迟加载时间 */
  background: linear-gradient(to top, #fff, #acd, cyan);
}
.seh > span {
  background: none;
  color: #fc5f29;
}
@keyframes run1 {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(100%);
  }
}

@keyframes run2 {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(100%);
  }
}

@keyframes run3 {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(-100%);
  }
}

@keyframes run4 {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(-100%);
  }
}
.box {
  position: relative;
  width: 100%;
  top: 10%;
  /* 重点：盒子宽度 150 */
  height: 90%;
  overflow: hidden;
}
.warp {
  height: 96%;
  width: 100%;
  padding-left: 10px;
  margin: 10px auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    li,
    a {
      display: block;
      height: 60px;
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      font-size: 15px;
    }
  }
}
/* 顶部、底部白色渐变 */
.header-blur {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 10px;
  /* background-image: linear-gradient(red, green 50%); */
  background-image: linear-gradient(#fff, rgba(0, 0, 0, 0) 50%);
  z-index: 1;
}
.footer-blur {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 10px;
  /* background-image: linear-gradient(red 40%, green); */
  background-image: linear-gradient(rgba(0, 0, 0, 0) 40%, #fff);
  z-index: 1;
}
// 超长部分 隐藏 显示点点点
.text-overflow-hidden {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
